import Button from '@/components/Button'
import FeaturedImage from '@/components/FeaturedImage'
import { formatDate, formatExcerpt } from '@/utilities/contentHelpers'

import classNames from 'classnames/bind'
import Link from 'next/link'
import styles from './PostFeed.module.scss'

let cx = classNames.bind(styles)
const postsAboveTheFold = 6

function PostFeed({ posts, id, onViewMore, canViewMore }) {
  return (
    <section {...(id && { id })} className={styles.posts}>
      <div className={cx('post-list')}>
        {posts?.map((post, i) => {
          let image = post?.featuredImage?.node

          return (
            <div className={cx('container')} key={post.id ?? ''} id={`post-${post.id}`}>
              <Link href={post?.uri ?? '#'} passHref>
                <div className={cx('card')}>
                  <FeaturedImage
                    className={cx('image')}
                    image={image}
                    width={540}
                    height={230}
                    priority={i < postsAboveTheFold}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  />

                  <div className={styles.headingInfo}>
                    <span className={styles.categoryName}>{post.categories.nodes.map((category) => category.name).join(', ')}</span>

                    <h4 className={cx('header', styles.headingTitle)} data-cy="post-feed-item-title">
                      {post.title}
                    </h4>

                    <p>{formatExcerpt(post.excerpt)}</p>

                    <p className={styles.date}>{formatDate(post.date)}</p>
                  </div>
                </div>
              </Link>
            </div>
          )
        })}
        {posts && posts.length < 1 && <p>No posts found.</p>}
      </div>

      {/* "Load More" button */}
      {canViewMore && (
        <div className={styles.loadMoreContainer}>
          <Button onClick={onViewMore}>Load More</Button>
        </div>
      )}
    </section>
  )
}

export default PostFeed
